"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactIntl = require("react-intl");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class Duration extends _react.default.PureComponent {
  render() {
    const duration = this.props.duration; // in seconds
    if (typeof duration === 'number') {
      const dur = _momentTimezone.default.duration(duration, 'seconds');
      // Assuming that hours is the largest unit
      const durationValues = {
        hours: dur.hours(),
        minutes: dur.minutes(),
        seconds: dur.seconds()
      };

      // We only show two sets of units
      if (durationValues.hours && durationValues.minutes) {
        durationValues.minutes += Math.round(durationValues.seconds);
        durationValues.seconds = 0;
      }
      if (durationValues.hours || durationValues.minutes || durationValues.seconds) {
        return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "au.trips.table.duration",
          values: durationValues
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "au.trips.table.noDuration"
        });
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("span", null);
    }
  }
  static propTypes = {
    duration: T.number
  };
}
exports.default = Duration;